<template>
  <section class="voting-percentage">
    <FlexWrap>
      <div class="container">
        <header class="message-holder">
          <transition mode="out-in" name="message">
            <h3>Maar hoeveel mensen registreerden zich in de praktijk als nieuwe kiezer?</h3>
          </transition>
        </header>
        <div class="full-box">
          <transition name="sheet">
            <img
              v-if="end"
              :src="require('@/assets/images/doos/7.svg')"
              alt=""
              draggable="false"
              class="sheet"
            />
          </transition>
          <img
            :src="require('@/assets/images/doos/back.svg')"
            alt=""
            draggable="false"
            class="back"
          />
          <img
            :src="require('@/assets/images/doos/front.svg')"
            alt=""
            draggable="false"
            class="front"
          />
        </div>
        <footer class="footer">
          <Button
            v-if="!end"
            @click.native="check"
          >laat zien</Button>
          <ScrollChevron
            scrollTo="#after-voting-percentage"
            :conditionals="end"
          />
        </footer>
      </div>
    </FlexWrap>
  </section>
</template>

<script>
import Button from '@/components/Button'
import { ScrollChevron, FlexWrap } from '@/components/chapter'
import { trekInteractive } from '@/utils/trek'

export default {
  name: 'VotingPercentage',
  data () {
    return {
      end: false
    }
  },
  components: {
    Button,
    ScrollChevron,
    FlexWrap
  },
  methods: {
    check () {
      trekInteractive('1896-percentage-hoeveel-mensen-maakten-gebruik')
      this.end = true
    }
  }
}
</script>

<style lang="scss" scoped>
.voting-percentage {
  background-color: $c-blue;
  position: relative;
  text-align: center;
}

h3 {
  font-size: 26px;
  font-weight: $fw-bold;
  text-align: center;
}

.message-enter-active,
.message-leave-active {
  transition: all 1600ms cubic-bezier(0.19, 1, 0.22, 1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.message-leave-active {
  transition-duration: 400ms;
}

.message-enter,
.message-leave-to {
  opacity: 0;
}

.message-enter {
  transform: translateY(-25px);
}

.message-leave-to {
  transform: translateY(25px);
}

.message-holder {
  color: white;
  height: 125px;
  margin: 0 auto 0.5em;
}

.footer {
  height: 120px;
  position: relative;
}

.container {
  position: relative;
  z-index: 2;
}

.full-box {
  position: relative;
  width: 275px;
  height: 400px;
  margin: 0 auto;
}

.back,
.front {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.back {
  z-index: 1;
}

.front {
  z-index: 3;
}

.sheet {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  width: 70px;
}

.sheet-enter-active,
.sheet-leave-active {
  transition: all 1600ms cubic-bezier(0.19, 1, 0.22, 1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.sheet-leave-active {
  transition-duration: 400ms;
}

.sheet-enter,
.sheet-leave-to {
  opacity: 0;
}

.sheet-enter {
  transform: translateY(155px);
}

.sheet-leave-to {
  transform: translateY(25px);
}
</style>
